import { IID } from "@shared/library";
import { IMeter } from "@webgest/library";

export type TStatus = "processed" | "suspended" | "attempted_processing" | "unprocessed";
export type TInterventionType = "installation" | "replacement" | "removal" | "reading" | "repair" | "georeferencing";
export type TViewMode = "installations" | "list" | "existentPlans";
export type TSubMode = "grid" | "map";

export interface IIntervention extends IID {
    ciu: number;
    municipality: number;
    lat?: number;
    lng?: number;
    alt?: number;
    supply_code?: number;
    supply_type?: number;
    identity_code?: number;
    old_reading?: number;
    new_reading?: number;
    diameter?: number;
    new_digits?: number;
    anomaly?: number;

    list_id?: string;
    intervention_id?: string;//list
    plan_id?: string;//edit
    accountholder: string;
    address: string;
    old_serial?: string;
    new_serial?: string;
    old_location?: string;
    new_location?: string;
    old_brand?: string;
    new_brand?: string;
    email?: string;
    specifics?: string;
    district?: string;
    odi?: string;
    causal?: string;
    notes?: string;
    result?: string;
    seal_code?: string;
    anomaly_notes?: string;
    annotations?: string;
    telephone?: string;
    operators?: string | string[];
    status?: TStatus;
    type: TInterventionType;
    witness?: string;
    valves?: string;
    custom_data?: string;

    intervention_date?: Date;
    old_reading_date?: Date;
    intervention_start_date?: Date;
    intervention_end_date?: Date;

    //UI ONLY
    fromMode?: TViewMode;
};

export interface IInterventionMarker {
    lat: number,
    lng: number,
    plan_id: string;
}

export class Intervention implements IIntervention {
    ciu: number;
    municipality: number;
    lat?: number;
    lng?: number;

    fromMode?: TViewMode;
    type: TInterventionType;
    address: string;
    old_serial: string;
    accountholder: string;
    old_brand?: string;

    constructor(meter: IMeter, currInterventionType: TInterventionType, mode?: TViewMode) {
        this.ciu = Number(meter.codiceUtente);
        this.address = `${meter.indirizzo} ${meter.civico}`;
        this.old_serial = meter.matricola;
        this.old_brand = meter.marca;
        this.accountholder = meter.intestatario;
        this.lat = meter.lat;
        this.lng = meter.lng;
        this.municipality = meter.idTipoUtenza!;
        this.type = currInterventionType;

        if (mode) {
            this.fromMode = mode;
        }
    }
}

export class InterventionEdit {
    plan_id: string = "";

    lat?: number;
    lng?: number;
    alt?: number;
    identity_code?: number;
    old_reading?: number;
    new_reading?: number;
    diameter?: number;
    new_digits?: number;
    anomaly?: number;

    status: TStatus = "unprocessed";
    old_serial?: string;
    new_serial?: string;
    old_location?: string;
    new_location?: string;
    old_brand?: string;
    new_brand?: string;
    email?: string;
    specifics?: string;
    district?: string;
    odi?: string;
    causal?: string;
    notes?: string;
    result?: string;
    seal_code?: string;
    valves?: string;
    anomaly_notes?: string;
    annotations?: string;
    telephone?: string;

    intervention_start_date?: Date;
    intervention_end_date?: Date;


    constructor(i: IIntervention) {
        if (i.plan_id && i.status && i.status !== "unprocessed") {
            this.plan_id = i.plan_id;
            this.status = i.status;
            this.lat = i.lat;
            this.lng = i.lng;
            this.alt = i.alt;
            this.identity_code = i.identity_code;
            this.email = i.email;
            this.telephone = i.telephone;
            this.old_brand = i.old_brand;
            this.new_brand = i.new_brand;
            this.old_serial = i.old_serial;
            this.new_serial = i.new_serial;
            this.old_reading = i.old_reading;
            this.new_reading = i.new_reading;
            this.old_location = i.old_location;
            this.new_location = i.new_location;
            this.seal_code = i.seal_code;
            this.valves = i.valves;
            this.diameter = i.diameter;
            this.new_digits = i.new_digits;
            this.odi = i.odi;
            this.district = i.district;
            this.intervention_start_date = i.intervention_start_date;
            this.intervention_end_date = i.intervention_end_date;
            this.notes = i.notes;
            this.annotations = i.annotations;
            this.anomaly = i.anomaly;
            this.anomaly_notes = i.anomaly_notes;
            this.result = i.result;
            this.causal = i.causal;
            this.specifics = i.specifics;
        }
    }
};